export default __webpack_public_path__ + "static/Museo-Sans-700-597e1846415a75abf922f2e38759a758.woff";